export enum DarkColors {
  'skyBlue' = '#0072B0',
  'calmLilac' = '#6048A1',
  'sunYellow' = '#D4B202',
  'zingyGreen' = '#4C8F0C',
  'aquaGreen' = '#069B7B',
  'warmOrange' = '#D96525',
}
